import Swiper from 'swiper';

const IntroSlider = () => {
  /* !----------------- SWIPER ------------------! */
  const containers = document.querySelectorAll('.page-section-intro-slider .swiper-container');

  if (!containers.length) return;

  containers.forEach(container => {
    // Get the id of the swiper, or its closest unique id
    const introSection = container.closest('.page-section-intro-slider');
    const id = introSection?.parentElement?.id;

    new Swiper(container, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: `#${id} .swiper-button-next`,
        prevEl: `#${id} .swiper-button-prev`,
      },
      pagination: {
        el: `#${id} .swiper-pagination`,
        clickable: true,
      },
    });
  });
};

export default IntroSlider;